import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  ${({ theme }) => css`
    padding: 32px 32px 32px 16px;
    display: flex;
    flex-direction: column;

    @media (max-width: ${theme.screenSizes.laptop}) {
      padding: 32px 16px;
    }
  `}
`
